import dealershipsData from './dealerships.drivesource.json';
import { Dealership } from '@/types/dealership.types';

export const getDealerships = (): Dealership[] => dealershipsData as Dealership[];

export const getDealershipBySlug = (slug: string): Dealership | undefined =>
    getDealerships().find(d => d.slug === slug);
